module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('el-checkbox', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c06e3c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Boolean.vue
// module id = 524
// module chunks = 1